export const zh_tw = {
    "TRIGGER_LISTEN": "正在聆聽觸發器",
    "ASSIST_EMPTY_MSG": "智能助手正在主動聆聽您的對話，並準備在觸發時自動提供協助。",
    "MYBOT_TRIGGET_LISTEN": "目前沒有活躍的 My Bot 任務",
    "MYBOT_EMTPY_MSG": "要在 My Bot 上開始任務，請轉到搜索選項卡並選擇 \"使用代理輸入運行\" 選項進行所需任務。",
    "PROACTIVE_MODE": "主動模式",
    "SETTINGS": "設置",
    "HELP_AND_SUPPORT": "幫助與支持",
    "HELP": "幫助",
    "LANGUAGE": "語言",
    "THEME": "主題",
    "AUTOMATIC": "自動",
    "DARK": "深色",
    "LIGHT": "淺色",
    "THEME_DESC": "這將使用您的系統默認模式",
    "DOCUMENTATION": "文檔",
    "DOC_DESC": "查看我們的深入文檔文章。",
    "FAQ_U": "常見問題",
    "FILE_NAME":"檔案名稱",
    "FAQ_DESC": "查看有關智能助手的常見問題。",
    "AUTO_SCROLL_TOOLTIP":"控制輔助標籤、我的機器人和轉錄標籤內容的自動滾動",
    "KORE_ACADEMY": "Kore 學院",
    "KORE_ACA_DESC": "通過學院課程了解更多有關智能助手的信息。",
    "SEARCH": "搜索",
    "MY_BOT": "我的機器人",
    "ASSIST": "協助",
    "TRANSCRIPT": "抄本",
    "HISTORY": "歷史",
    "TAB_TEXT":"未啟用任何標籤！請至少啟用一個標籤",
    "STARTOVER": "重新開始",
    "RESTART_INPUTS": "使用捕獲的輸入重新開始",
    "ASKCUSTOMER": "詢問客戶",
    "TELLCUSTOMER": "告訴客戶",
    "WELCOME_MSG": "歡迎消息",
    "SEND": "發送",
    "SENT": "已發送",
    "TAP_SEARCH":"點擊搜尋",
    "AWAITING": "等待回應 | 輸入以繼續",
    "OVERRIDE": "輸入以繼續",
    "OVERRIDE_FILE": "附加文件以繼續",
    "ACCEPT_RESPONSE": "響應已接受",
    "AGENT_ENTERED": "代理已進入",
    "EXPECTED_FORMAT": "預期格式",
    "INPUT_VALUES": "輸入值",
    "RESTART": "重新開始",
    "START_OVER": "重新開始",
    "RESTART_CAPTURE": "使用捕獲的輸入重新開始",
    "CANCEL": "取消",
    "INTERRUPT_DIALOG": "中斷對話任務",
    "RUN": "運行",
    "RUN_AGENT": "使用代理的輸入運行",
    "STEP": "步驟",
    "DIALOG_TASK": "對話任務",
    "FAQ": "常見問題",
    "SNIPPET": "答案",
    "ARTICLE": "網頁",
    "FILE": "文件",
    "SUGGESTED": "建議的",
    "ALL_DIALOG": "所有對話任務",
    "DIALOG_TEXT": "對話",
    "INTENT_IDENTIFIED": "客戶話語",
    "NOT_WHAT_LOOKING": "錯誤的建議？",
    "BOT": "機器人",
    "CUSTOMER": "客戶",
    "YOU": "你",
    "TERMINATE_CONV": "終止對話任務",
    "TERMINATE_CONV_DESC": "您確定要終止對話任務嗎？智能助手將無法再提供建議。",
    "YES_TERMINATE": "是，終止",
    "NO_CANCEL": "否，取消",
    "OVERRIDE_CONTINUE": "繼續使用覆蓋模式",
    "SUMMARY_TEXT": "摘要",
    "SUBMIT": "提交",
    "INTERRUPT_OCCURED": "發生中斷",
    "IDENTIFIED_INTENT": "識別的意圖",
    "INTERRUPT_DESC": "執行此操作將終止您正在進行的對話任務。",
    "ACCEPT_RUN": "接受並運行",
    "RUN_LATER": "稍後運行",
    "KNOW_MORE": "了解更多",
    "MORE_TEXT": "更多",
    "LESS_TEXT": "更少",
    "VIEW_MORE": "查看更多",
    "VIEW_LESS": "查看更少",
    "SHOW_MORE_FAQ": "顯示更多常見問題",
    "SHOW_LESS_FAQ": "顯示更少常見問題",
    "SHOW_MORE_ARTICLE": "顯示更多網頁",
    "SHOW_LESS_ARTICLE": "顯示更少網頁",
    "SHOW_MORE_SNIPPET": "顯示更多答案",
    "SHOW_LESS_SNIPPET": "顯示更少答案",
    "SHOW_MORE_FILES": "顯示更多文件",
    "SHOW_LESS_FILES": "顯示更少文件",
    "VIEW_ALL_DIALOG": "查看所有對話",
    "VIEW_FEW_DIALOG": "查看幾個對話",
    "HELP_FULL": "有幫助嗎？",
    "THANKYOU": "謝謝！",
    "EXPAND_MORE": "展開 / 更多",
    "CLOSE_TEXT": "關閉",
    "STARTED": "開始",
    "ENDED": "結束",
    "VIEW_FULL_ARTICLE": "查看網頁",
    "VIEW_FULL_FILE": "查看文件",
    "COPIED": "已複製",
    "SENTI_ANALY": "情感分析",
    "WRONG_SUGGESTION": "錯誤的建議",
    "INCORRECT_INTENT": "不正確的意圖",
    "ACCIDENTAL_CLICK": "意外點擊",
    "TIME_TAKING": "耗時",
    "OTHER": "其他",
    "PLAYBOOK_EMPTY_MSG": "選擇播放手冊",
    "PLAYBOOK_EMPTY_DESC": "智能助手無法加載播放手冊，因為所有可用的播放手冊都是動態的。點擊 '選擇播放手冊' 以訪問播放手冊",
    "STAGE": "階段",
    "PROCEED_TO_CLOSE": "繼續關閉",
    "RECOMENDED_PLAYBOOK": "推薦的播放手冊",
    "PRIMARY_SCRIPTS": "主要腳本",
    "DYNAMIC_SCRIPTS": "動態腳本",
    "RESUME": "恢復",
    "ENABLE_CLOSE": "點擊繼續關閉按鈕以啟用關閉階段",
    "LIST_VIEW": "列表視圖",
    "TERMINATE": "終止",
    "MINIMIZE": "最小化",
    "MAXIMIZE": "最大化",
    "NO_SEARCH_RESULT": "未找到搜索結果",
    "SENTIMENT_AWAITING": "等待情感分析",
    "POSITIVE": "正面",
    "NEGATIVE": "負面",
    "ASSOCIATED_WORK_NOTES": "過去的解決方案筆記",
    "AGENT_JOINED_CONV": "代理已加入對話",
    "AUTOSCROLL_ASSIST": "自動滾動助手標籤內容",
    "FILE_SIZE_MSG": "文件大小必須在25MB以內。請重試。",
    "OVERRIDE_BTN": "覆蓋",
    "CHOOSE_FILE": "選擇文件",
    "SUMMARY_ERROR_TEXT": "我們抱歉，但生成此對話的摘要時出現問題。請自行創建摘要。",
    "ASK_A_QUESTION": "提出問題",
    "COPY": "複製",
    "TELL_US_MORE": "告訴我們更多……",
    "THANKS_FEEDBACK": "感謝您的反饋",
    "SOMETHING_WRONG": "發生了一些錯誤",
    "CLICK_ERROR_DETAILS": "點擊以查看錯誤詳情",
    "NO_ACTIVE_PLAYBOOK": "沒有活動的劇本",
    "REPHRASE_QUESTION": "您可以重新表達您的問題或問其他事情嗎？",
    "VIEW_FULL_ARTICLE_2": "查看完整文章",
    "VIEW_FULL_FILE_2": "查看完整文件",
    "INTERNAL_INFO": "內部資訊",
    "SOURCES": "來源",
    "CONVERSATION_SUMMARY": "對話摘要",
    "WAITING": "等待中",
    "WIDGET_DISABLED": "小工具已禁用",
    "AI_SETTINGS_DISABLED": "AI設置已禁用！請聯繫AI管理員",
    "SERVER_CONNECTION_ERROR": "連接到伺服器時發生錯誤",
    "VIEW": "查看",
    "ATTACHMENT_INPUT": "附件輸入",
    "TYPE_SUMMARY": "輸入摘要",
    "BY":"由",
    "PLAYBOOK": "劇本",
    GENERATE_SUMMARY: "生成摘要",
    PREV_SUMMARIES: "先前生成的摘要",
    DIALOG_WORKFLOWS: "對話工作流程",
    SHOW_ALL_DIALOG: "顯示所有對話任務",
    SHOW_ALL_DIALOGS: "顯示所有對話",
    CUSTOM_TAB: "自定義分頁",
    AGENT_INPUT: "代理輸入",
    CUSTOM_EMPTY_MSG: "目前沒有活動的流程",
    CUSTOM_TAB_DESC: "要啟動流程，請從螢幕底部的清單中執行一個。",
    SUBMIT_OVERALL_FEEDBACK: "提交總體反饋",
    FEEDBACK_POPUP_SUBTITLE: "關於小部件及其功能的反饋",
    FEEDBACK_SATISFIED: "滿意",
    FEEDBACK_UNSATISFIED: "不滿意",
    FEEDBACK_PROVIDE_REASONS: "提供更多信息...",
    FEEDBACK_TITLE: "反饋", 
    "AGENTIC_THINKING" : "思考中",
    "AGENTIC_AGENT_TITLE" : "代理",
    "AGENTIC_COPILOT_MODE_TITLE" : "代理副駕駛模式",
    "AGENTIC_SENDING_MESSAGE" : "傳送中...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot正在積極傾聽您的對話，並準備自動提供協助",
    "AGENTIC_SEARCH_RESULTS" : "代理結果"
}